export default "__VITE_ASSET__c281a0ba__"